<template>
    <div>
        <college-banner></college-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Edit Profile</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="college-profile-form">
                                    <form action="" @submit.prevent="update">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="epp">
                                                    <div class="edit-profile-pic">
                                                        <img v-bind:src="image" v-if="image">
                                                        <img src="/images/user_avatar.png" v-else>
                                                        <label for="cp-edit"><i class="fas fa-pencil-alt"></i></label>
                                                    </div>
                                                    <div class="pic-details">
                                                        <input type="file" id="cp-edit" class="file" @change="onPhotoUploaded">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="change-form-data">
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="first_name">First Name</label>
                                                        <input type="text" class="form-control dash-input" id="first_name" placeholder="First Name"
                                                               name="first_name"  v-model="first_name" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="last_name">Last Name</label>
                                                        <input type="text" class="form-control dash-input" id="last_name" placeholder="Last Name"
                                                               name="first_name"  v-model="last_name" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="college">College</label>
                                                        <input type="text" class="form-control dash-input" id="college" placeholder="College"
                                                               name="first_name"  v-model="college" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="location">Location</label>
                                                        <input type="text" class="form-control dash-input" id="location" placeholder="Location"
                                                               name="first_name"  v-model="location">
                                                        <div id="location-er" v-html="location_error" class="form-text text-muted"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="phone">Phone</label>
                                                        <input type="text" class="form-control dash-input" id="phone" placeholder="Phone Number"
                                                               name="first_name"  v-model="phone" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="email">Email</label>
                                                        <input type="text" class="form-control dash-input" id="email" placeholder="Email"
                                                               name="first_name"  v-model="email" disabled>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group text-center">
                                                <button class="update-profile" type="submit">Update</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import toastr from  '../../../public/js/toastr.js';
    import CollegeSideNavLayout from "../../components/CollegeSideNavLayout";
    import collegeBanner from "../../components/collegeBanner";
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data(){
            return {
                image:'',
                uploadedPhoto: null,
                college:'',
                college_enc_id:'',
                phone:'',
                email:'',
                first_name:'',
                last_name:'',
                location:'',
                //variable for job prefs
                location_error:'',
            }
        },
        mounted(){
            var t = this;
            var user = this.$store.getters.getUser;
            var url = this.$store.getters.getDomain;
            t.first_name = user['first_name'];
            t.last_name = user['last_name'];
            t.college = t.htmlDecoder(user['college']);
            t.college_enc_id = user['college_enc_id'];
            t.phone = user['phone'];
            t.email = user['email'];
            t.location = user['city'];

            axios.post(`${url}api/v2/cand-profile/profile-picture`, '',{
                headers: requestHeaders()
            }).then(function (response) {
                document.getElementById("h-page-load").classList.add("hides");
                t.image = response['data'];
            }).catch(function (error) {
                // console.log(error)
            });
        },
        computed: {
            changeImage() {
                return this.$store.getters.getImage;
            },
        },
        watch: {
            changeImage(value) {
                var t = this;
                t.image = value;
            },
        },
        methods: {
            onPhotoUploaded(event){
                var t = this;
                var url = this.$store.getters.getDomain;
                this.uploadedPhoto = event.target.files[0];
                const fd = new FormData();
                fd.append('profile_image', this.uploadedPhoto, this.uploadedPhoto.name);

                showLoader();
                axios.post(`${url}api/v2/cand-profile/upload-profile-picture`, fd, {
                    headers: requestHeaders(),
                    // onUploadProgress: uploadEvent => {
                    //     console.log('Upload Progress: ' + Math.round(uploadEvent.loaded/uploadEvent.total * 100) + "%")
                    // }
                })
                    .then(res => {
                        hideLoader();
                        if(res.status == 200) {
                            var image = res['data']['response']['image'];
                            t.$store.dispatch("setImage", image);
                            toastr.success('Picture Uploaded Successfully', 'Success');
                        }else{
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })

            },
            update(){
                var t = this;
                var url = this.$store.getters.getDomain;

                t.location_error = '';

                if(t.location == "" || t.location == null){
                    t.location_error = "location can't be empty";
                    return false;
                }

                var data = {
                    'location': t.location,
                };

                if(t.location){
                    showLoader();
                    axios.post(`${url}api/v2/cand-profile/save-basic-info`, data,{
                        headers: requestHeaders()
                    }).then(function (response) {
                        hideLoader();
                        t.$store.dispatch('setUser', response['data']['response']['data']);
                    }).catch(function (error) {
                        console.log(error)
                    });
                }
            },
            htmlDecoder (str) {
                var textArea = document.createElement('textarea');
                textArea.innerHTML = str;
                return textArea.value;
            }
        }
    }
</script>